import styled from "styled-components";

const Divider = styled.div`
    display: flex;
    width: 100%;
    height: 1px;
    background-color: #575454;
    flex-grow: 1;
`

export default Divider;